const pluralS = (count: number) => {
	return count === 1 ? "" : "s";
};
export default pluralS;
